import React, { Component } from 'react';
import { Spin } from 'antd';

import './index.css'

type StateProps = {
	tip: string
}


type IProps = StateProps

interface Loading {
	props: IProps
}

class Loading extends Component<IProps> {

	render() {
		const { tip } = this.props
		return (
			<div className="loading">
				<div className="container">
					<Spin className="spin" tip={tip} size="large"></Spin>
				</div>
			</div>
		)
	}
}

export default Loading